import { memo } from 'react';
import { Button, ButtonGroup, DialogBody, DialogContainer, DialogFooter, DialogHeader } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';
import { useAppDispatch } from '~/store';
import { claimClanTasksThunk } from '~/Actions/ActionClanTasks';

import { TASK_DESCRIPTIONS } from '~/pages/ClanTasks/constants';

import styles from './ClanTasksRewardsDialog.scss';

import type { ClanTask, ClanTaskReward } from '~/Actions/ActionClanTasks';
import type { IDialog } from '~/types/declaration';

type ClanTasksRewardsDialogProps = IDialog<{
  tasks: ClanTask[];
  aggregatedReward: ClanTaskReward;
}>;

const ClanTasksRewardsDialog = ({ data, hideDialog }: ClanTasksRewardsDialogProps) => {
  const dispatch = useAppDispatch();

  const { tasks, aggregatedReward } = data;

  const sorted = [...tasks].sort((a, b) => (a.order > b.order ? 1 : -1));

  const claimClanTasks = () => {
    void dispatch(claimClanTasksThunk());
  };

  return (
    <DialogContainer>
      <DialogHeader>{t('Полученные награды')}</DialogHeader>
      <DialogBody>
        <div className={styles.aggregateRewardDescription}>
          <span className={styles.aggregateRewardDescriptionSubTitle}>{t('Выполненные задачи клана:')}</span>
          <br />
          <span className={styles.aggregateRewardDescriptionTasks}>
            {sorted
              .filter((task) => task.isFinished && !task.isClaimed)
              .map((task) => TASK_DESCRIPTIONS[task.name as keyof typeof TASK_DESCRIPTIONS].title)
              .join(', ')}
          </span>
          <br />
          <span className={styles.aggregateRewardDescriptionRewardTitle}>
            {t('Награда будет помещена в клановую казну.')}
          </span>
          <br />
          {aggregatedReward.coal ? (
            <div className={styles.coal}>
              <span>{aggregatedReward.coal}</span>
            </div>
          ) : null}
          {aggregatedReward.oil ? (
            <div className={styles.oil}>
              <span>{aggregatedReward.oil}</span>
            </div>
          ) : null}
        </div>
      </DialogBody>
      <DialogFooter>
        <ButtonGroup>
          <Button
            isJustified
            isFlat
            onClick={() => {
              claimClanTasks();
              hideDialog();
            }}
          >
            {t('Забрать награду')}
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </DialogContainer>
  );
};

export default memo(ClanTasksRewardsDialog);
